import { render, staticRenderFns } from "./traineePreassessmentReport.vue?vue&type=template&id=6a5c62da&scoped=true"
import script from "./traineePreassessmentReport.vue?vue&type=script&lang=js"
export * from "./traineePreassessmentReport.vue?vue&type=script&lang=js"
import style0 from "./traineePreassessmentReport.vue?vue&type=style&index=0&id=6a5c62da&prod&scoped=true&lang=css"
import style1 from "./traineePreassessmentReport.vue?vue&type=style&index=1&id=6a5c62da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c62da",
  null
  
)

export default component.exports